module.exports = __webpack_public_path__ + "img/ton_meshi.1c5cf475.png";